import styled from 'styled-components';

export const PageWrapper = styled.div`
  direction: ${(props) => props.theme.direction};
`;

export const MainLayout = styled.div`
  display: block;
  iframe {
    width: 100%;
    height: 430px;
    border: 0;
  }
  .accordion-header-content{
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
  }
  .accordion-detail-panel{
    font-weight: 400;
  }
   table tr:first-of-type td{
    background: #B7D5FE !important;
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }
  p {
    color: #314259;
    margin: 20px 0;
    line-height: 24px;
    font-size: 18px;
    font-weight: 500;
  }
  .youtube-player{
    height:500px;
  }
  .tube-div{
  height: 600px;
    position: static !important;
  }
  .grey-block {
    background: #d0e4fe;
    padding: 30px;
  }
  blockquote {
    padding: 4px 16px;
    background-color: aliceblue;
  }
  h2 {
    margin: 40px 0 30px;
    font-size: 24px;
    line-height: 100%;
  }
  h2.faq-title{
    margin: 0;
    font-size: 20px;
    line-height: 100%;
    font-weight: 600;
  }
  h3 {
    margin: 40px 0 30px;
    font-size: 20px;
    line-height: 100%;
  }
  h4 {
    margin: 40px 0 30px;
    font-size: 18px;
    line-height: 100%;
  }
  ol,
  ul,
  li {
    margin: 10px;
    font-weight: 500;
    line-height: 24px;
    font-size: 18px;
    color: #314259;
    list-style: auto;
  }
  ul, li {
    list-style: disc;
  }
  
  ol li {
    list-style: decimals;
  }
  a span u , a span strong, a span, a ul {
    color : #1678FB;
    text-decoration: none;
  }
  .table{
    display: block;
    width: 100%;
    overflow-x: auto;
    -ms-overflow-style: none;
      ::-webkit-scrollbar {
        padding: 10px;
        width: 5px; 
        height: 5px;
        background-color: #e3ecf8; /* Light background for scrollbar track */
      }
      ::-webkit-scrollbar-thumb {
        background-color: #9fc1ed; /* Color of the scrollbar thumb */
        border-radius: 4px; /* Rounded corners for the thumb */
      }
      ::-webkit-scrollbar-thumb:hover {
        background-color: #9fc1ed; /* Darker shade when hovered */
      }
  }
  
  tbody tr:nth-of-type(even) {
  background-color: #F3F8FF
}

  tbody tr:nth-of-type(odd) {
  background-color: #FFFFFF
}

  table {
    border-spacing: 0;
    width: 100%;
    border-radius: 5px;
    overflow-x: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::-webkit-scrollbar {
      display:none;
    }
}
  }
  table th,
  table td {
    color: #314259;
    line-height: 24px;
    margin: 10px 0;
    font-size: 18px;
    padding: 10px !important;
    border: 0.5px solid #8EBEFD !important;
    border-collapse: collapse;
  }
  }
  table thead {
    background-color: rgb(242, 242, 242) !important;
    font-weight: 700;
    tr {
      padding: 10px 0;
    }
  }
  table th{
  background: #B7D5FE;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
}
  tbody {
    tr:first-child {
    background: #B7D5FE;
      td {
        font-size: 18px;
        line-height: 24px;
        font-weight: 600;
      }
    }
  }
  .rc-component {
    padding: 5px 10px;
    margin: 20px 0;
    border: solid 1px #dfdfdf82;
    border-radius: 5px;
    background-color : #78a9ea82;
    h2, h3 {
      margin: 10px 0;
    }
  }
  .youtube-player {
    border-radius: 10px;
    border: 1px solid rgba(51, 51, 51, 0.1);
    overflow: hidden;
    z-index: 1;
    margin: 50px 0;
  }
  table tr:first-of-type td:first-of-type{
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
  }

  h2 *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
  
  h3 *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  h4 *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  .accordion-detail-panel *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  li *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  @media (max-width: 768px) {
    .youtube-player{
      height: 200;
    }
    .tax-deduction-li {
      width: 40%;
    }
    p{
      line-height: 24px;
      font-size: 16px;
      font-weight: 400;
    }
    li{
      line-height: 24px;
      font-size: 16px;
      font-weight: 400;
    }
    table td{
      line-height: 22px;
      font-size: 14px;
      font-weight: 400;
    }
    table tr td:first-child p{
      width: 150px;
      text-wrap: auto;
    }
    table tr td {
      max-width: 250px;
      min-width: 150px;
      text-wrap: initial;
      p {
        text-align: center !important;
      }
    }
      table tr:first-of-type td:first-of-type{
      background: #B7D5FE !important;
      }
      thead tr th:first-child{
        position: sticky;
        left: -1px;
        z-index: 1;
        background: #B7D5FE;
        border: 0.5px solid #8EBEFD!important;
        max-width: 200px;
        min-width: 150px;
        text-wrap: initial;
      }

      tbody tr:nth-of-type(even) td:first-child {
      background-color: #F3F8FF
    }

      tbody tr:nth-of-type(odd) td:first-child {
      background-color: #FFFFFF
    }

    tbody {
      tr td:first-child {
        position: sticky;
        left: -1px;
        z-index: 1;
        max-width: 200px;
        min-width: 150px;
        text-wrap: initial;
      }
    }
    h2{ font-size: 20px; line-height: 28px; font-weight: 700;}
    h3 {font-size: 18px; line-height: 100%; font-weight: 700;}
    h4 {font-size: 18px; line-height: 100%; font-weight: 700;}
    h2.faq-title{
    margin: 0;
    font-size: 20px;
    line-height: 100%;
    font-weight: 700;
    }
    .accordion-header-content{
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    }
    iframe {height: 200px;}
    table {
      white-space: nowrap;
      width: 100%;
    }
    
    /* Fix for corner borders in mobile view */
    table::before,
    table::after,
    table > tbody::before,
    table > tbody::after {
      z-index: 10; /* Ensure corners appear above other elements */
    }
    
    /* Specifically fix the bottom-left corner for mobile */
    table > tbody::after {
      position: fixed; /* Use fixed positioning in mobile */
      bottom: 0;
      left: 0;
      width: 20px;
      height: 20px;
      border-width: 0 0 0.5px 0.5px;
      border-radius: 0 0 0 20px;
    }
  }

  table{
    overflow: hidden;
    border-radius: 20px;
    border-collapse: separate;
    border: none;
    position: relative;
    
    &::before,
    &::after {
      content: '';
      position: absolute;
      width: 20px;
      height: 20px;
      border-color: rgb(142, 190, 253);
      border-style: solid;
    }
    
    /* Top-left corner */
    &::before {
      top: 0;
      left: 0;
      border-width: 0.5px 0 0 0.5px;
      border-radius: 20px 0 0 0;
    }
    
    /* Bottom-right corner */
    &::after {
      bottom: 0;
      right: 0;
      border-width: 0 0.5px 0.5px 0;
      border-radius: 0 0 20px 0;
    }
  }
  
  /* Additional pseudo-elements for the other two corners */
  table > tbody::before,
  table > tbody::after {
    content: '';
    position: absolute;
    width: 20px;
    height: 20px;
    border-color: rgb(142, 190, 253);
    border-style: solid;
  }
  
  /* Top-right corner */
  table > tbody::before {
    top: 0;
    right: 0;
    border-width: 0.5px 0.5px 0 0;
    border-radius: 0 20px 0 0;
  }
  
  /* Bottom-left corner */
  table > tbody::after {
    bottom: 0;
    left: 0;
    border-width: 0 0 0.5px 0.5px;
    border-radius: 0 0 0 20px;
  }

  table tr:first-of-type td{
    background: #B7D5FE !important;
    font-size:16px;
    line-height: 24px;
    font-weight: 600;
  }

  table th{
    font-size:16px;
    line-height: 24px;
    font-weight: 600;
  }

  p *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
  
  td *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
  
  th *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  li *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  h2 *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  h4 *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  h3 *{
    line-height: inherit;
    font-size: inherit;
    font-weight: inherit;
  }
  
  li strong {
    font-weight: 700;
  }

  p strong {
    font-weight: 700;
  }

  td strong {
    font-weight: 600;
  }


  @media (min-width:769px) and (max-width:1024px)
  {
    iframe {height:281px}
  }
  @media (min-width:769px)
  {
    table{
      width: 100%;
    }
    .table{
      width: 100%;
    }
    
  }
`;

export const BreadCrumbLayout = styled.div`
  font-size: 14px;
`;

export const LeftArticleContainer = styled.div`
  h2 a {
    color: #628b9f;
  }
  ul {
    list-style: none;
    padding: 0;
  }

  li > a {
    font-size: 12px;
    color: #628b9f;
    padding: 8px 0;
    display: block;
    font-weight: 400;
    text-decoration: none;
    border-bottom: 1px solid #f1f1f1;
  }
`;

export const CTContainer = styled.div`
  justify-content: space-between;
  background: rgba(208, 228, 254, 0.2);
  align-items: center;
  .container {
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
  }
  .email-searchBox {
    padding: 5px 7px;
    margin-bottom: 5px;
  }
`;

export const NewToCContainer = styled.div`
  .TOC_index {
    .tocAnchorTag {
      line-height: 18px;
      font-size: 14px;
      color: #314259;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-height: 23px;
      overflow: hidden;
    }
    ul li {
      padding: 13px 20px;
    }
    .activeIndex {
      border-left: 2px solid #1572ed;
      padding: 13px 20px 13px 18px;
      background-color: #ebf4ff;
    }
    li:last-child {
      margin-bottom: 0;
    }

    @media (max-width: 768px) {
      ul {
        padding: 20px;
        margin-top: 0;
      }
      ul li {
        padding: 8px 10px;
      }
    }
    @media (max-width: 1024px) and (min-width: 768px) {
      a {
        font-size: 14px;
      }
    }
  }

  .indexTOC::-webkit-scrollbar {
    width: 4px; /* Set the width of the scrollbar */
  }

  .indexTOC::-webkit-scrollbar-thumb {
    background-color: #9fc1ed; /* Color of the scrollbar thumb */
    border-radius: 4px; /* Rounded corners for the thumb */
  }

  .indexTOC::-webkit-scrollbar-thumb:hover {
    background-color: #9fc1ed; /* Darker shade when hovered */
  }

  .indexTOC::-webkit-scrollbar-track {
    background-color: #e3ecf8; /* Background color of the track */
    margin-left: 20px;
  }
`;

export const ToCContainer = styled.div`
  max-height: 350px;
  overflow-y: auto;
  color: #808080;

  #contentsOfTable {
    opacity: 1;
    height: auto;
    padding: 10px;
  }
  ul {
    padding: 5px;
    margin: 0 !important;
  }
  li {
    color: grey;
    font-weight: 400;
    padding: 5px 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  li a {
    color: grey;
  }

  .calculator {
    padding: 48px;
    background: #ffffff;
  }
  .calculator ul {
    padding: 0px;
  }
  .calculator #contentsOfTable {
    padding: 0px;
  }
  .calculator li a {
    font-size: 16px;
    color: #1678fb;
    padding: 0px;
    margin: 0px;
  }
  .calculator li {
    padding: 0px 0px;
    margin: 16px 0px;
    line-height: 18px;
  }
`;

export const ToCContainerMobile = styled.div`
  li a {
    color: #314259;
  }
`;
